module.exports = __webpack_public_path__ + "img/product.1cfdddd5.svg";